import React, { useEffect, useState } from 'react'
import './WeatherApp.css'
import searchIcon from './Images/search.png'
import rainIcon from './Images/rain.png'
import humidityIcon from './Images/humidity.png'
import windIcon from './Images/wind.png'
import sunIcon from './Images/clear.png'
import cloudIcon from './Images/clouds.png'
import snowIcon from './Images/snow.png'
import drizzleIcon from './Images/drizzle.png'
import mistIcon from './Images/mist.png'
import axios from 'axios'
export const WeatherApp = () => {
    const [home, setHome] = useState(null)
    const [city, setCity] = useState('')
    const [weather, setWeather] = useState(null)
    const [error, setError] = useState('')
    const [clicked, setClicked] = useState(false)

    const API_KEY = "928df6f3f0bb80f89e509c7cb0d9f2f0"
    const API_URL = "https://api.openweathermap.org/data/2.5/weather?units=metric&q="
    const DEFAULT_CITY = 'Sikandrabad'

    const weatherImages = {
        Clear: sunIcon,
        Clouds: cloudIcon,
        Rain: rainIcon,
        Snow: snowIcon,
        Drizzle: drizzleIcon,
        Mist: mistIcon
    }

    const backgroundGradients = {
        Clear: 'linear-gradient(135deg, #FFA07A, #FFC400)', // Light Salmon to Golden Yellow
        Clouds: 'linear-gradient(135deg, #B0C4DE, #4682B4)', // Light Steel Blue to Steel Blue
        Rain: 'linear-gradient(135deg, #7EC8E3, #005B96)', // Light Blue to Dark Blue
        Snow: 'linear-gradient(135deg, #FFFFFF, #D3D3D3)', // White to Light Gray
        Drizzle: 'linear-gradient(135deg, #A9A9A9, #696969)', // Dark Gray to Dim Gray
        Mist: 'linear-gradient(135deg, #D3D3D3, #A9A9A9)' // Light Gray to Dark Gray
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_URL}${DEFAULT_CITY}&appid=${API_KEY}`)
                setHome(response.data)
            } catch (error) {
                setHome(null)
                setError('City not found. Please try again.')
            }
        }
        fetchData()
    }, [])

    const fetchWeather = async () => {
        setClicked(true)
        try {
            const response = await axios.get(`${API_URL}${city}&appid=${API_KEY}`)
            setWeather(response.data)
            setError('')
            setCity('')
        } catch (error) {
            setWeather(null)
            setError('City not found. Please try again.')
        }
        if (city.length === 0) {
            alert(error)
        }
        setTimeout(() => {
            setClicked(false)
        }, 200)
    }

    const getWeatherImages = (condition) => {
        return weatherImages[condition] || sunIcon
    }

    const handleCityChange = (e) => {
        setCity(e.target.value)
    }

    const handleSearchClick = () => {
        fetchWeather()
    }


    return (
        <div>
            <div className="card">
                <div className="search">
                    <input value={city} type="text" placeholder="Enter city" spellCheck={false} onChange={handleCityChange} required />
                    <button className={clicked ? 'clicked' : ''} id="srchBtn"><img src={searchIcon} onClick={handleSearchClick} alt='Search' /></button>
                </div>
                {(weather || home) ? (
                    <div>
                        <div className="weather">
                            <img id="icon" className="weather-icon" src={getWeatherImages((weather ? weather.weather[0].main : home.weather[0].main))} alt='Weather Icon' />
                            <h1 id="temp" className="temp">{(weather ? weather.main.temp : home.main.temp)}°c</h1>
                            <h2 id="city" className="city">{(weather ? weather.name : home.name)}</h2>
                            <div className="details">
                                <div className="col">
                                    <img src={humidityIcon} alt="Humidity Icon" />
                                    <div>
                                        <p id="humidity" className="humidity">{(weather ? weather.main.humidity : home.main.humidity)}%</p>
                                        <p>Humidity</p>
                                    </div>
                                </div>
                                <div className="col">
                                    <img src={windIcon} alt="Wind Icon" />
                                    <div>
                                        <p id="wind" className="wind">{(weather ? weather.wind.speed : home.wind.speed)}km/h</p>
                                        <p>Wind Speed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (<p>{error}</p>)}
            </div>
        </div>
    )
}
